import { render, staticRenderFns } from "./LayoutProperty.vue?vue&type=template&id=5d044c51&scoped=true&"
import script from "./LayoutProperty.vue?vue&type=script&lang=js&"
export * from "./LayoutProperty.vue?vue&type=script&lang=js&"
import style0 from "./LayoutProperty.vue?vue&type=style&index=0&id=5d044c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d044c51",
  null
  
)

export default component.exports